import alongsideSubtitle from '../alongsideSubtitle';
import FlavorsTable from 'components/DataVis/FlavorsTable';
import { useEntityPageContext } from './EntityContext';

/** The flavors table, on the food surfaces that have one. */
const EntityFlavors = ({
    dataSource,
    subject = 'flavors',
    exportEntity,
    dated = true,
    parented = false,
    ...rest
}) => {
    const { entity, entityId, country, week, year, name, exportName } =
        useEntityPageContext();

    return (
        <FlavorsTable
            category={entityId}
            country={country ? country.id : null}
            dataSource={dataSource}
            {...(dated && { week, year })}
            icon="flavor"
            title="Flavors"
            subtitle={alongsideSubtitle(subject, name)}
            filename={exportName('flavor', { entity: exportEntity })}
            name={name}
            {...(parented && {
                parentEntity: entity,
                parentEntityType: 'category',
                parentEntityId: entityId,
            })}
            {...rest}
        />
    );
};

export default EntityFlavors;
